/**
 *
 */
export const moon = {
    paths: [
        {
            d: 'M9.598 1.591a.749.749 0 0 1 .785-.175 7.001 7.001 0 1 1-8.967 8.967.75.75 0 0 1 .961-.96 5.5 5.5 0 0 0 7.046-7.046.75.75 0 0 1 .175-.786Zm1.616 1.945a7 7 0 0 1-7.678 7.678 5.499 5.499 0 1 0 7.678-7.678Z',
        },
    ],
    viewBox: '0 0 16 16',
};
//# sourceMappingURL=moon.js.map